import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { LOGIN_ROUTE } from "../../routes/RoutesPathes";

export const RequireAuth = () => {
  const { auth } = useAuth();
  const location = useLocation();

  return (
    auth?.email ? <Outlet /> : <Navigate to={LOGIN_ROUTE} state={{ from: location }} replace />
  )
};
